import * as CampaignSettingAccessors from './accessors';
export { CampaignSettingAccessors };
export default Object.assign({}, CampaignSettingAccessors);
